












import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    getCompany,
    postCompany,
    patchCompany,
    getCompanies,
    patchCompanyContactedAt, getBusinessDevelopers,
} from '../api/api';
import Company from '../models/Company';
import { BACKEND_URL } from '../helpers/constants';
import { legalForms } from '@/data/legalForms';
import { companyTypes } from '../data/companyTypes';
import get from 'lodash/get';
import FileCurrent from '@/models/FileCurrent';
import router from '@/router';
import moment from 'moment';
import User from '@/models/User';

let company: Company | null = null;

async function getCompanyForRouter(companyID: string) {
    try {
        const { data } = await getCompany(+companyID);
        return data;
    } catch (error) {
        console.warn(error, get(error, 'response.data.message'));
        return null;
    }
}

function getCompanyName(value: Company | null) {
    if (value) {
        return value.name;
    }
    return null;
}

@Component({
    beforeRouteEnter: async (to, from, next) => {
        const { route } = router.resolve({
            name: 'companies',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        if (to.params.id) {
            company = await getCompanyForRouter(to.params.id);

            if (company == null) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Entreprise introuvable.`,
                });

                next({
                    name: 'companies',
                });
                return;
            } else {
                to.meta.breadcrumb[2].title = getCompanyName(company);
            }
        }

        next();
    },
    beforeRouteUpdate: async (to, from, next) => {
        if (to.params.id) {
            company = await getCompanyForRouter(to.params.id);
            to.meta.breadcrumb[2].title = getCompanyName(company);
        }

        next();
    },
    components: {
        Forms,
    },
})
export default class CompanyForm extends Vue {
    title: string = '';
    company: Company | null = company;
    businessDeveloppers: Array<{ text: string; value: number }> = [];
    companiesItems: Array<{ text: string; value: number }> = [];
    methodesFlux:Array<{ text: string; value: string }> = [];
    loading: boolean = false;
    defaultImages: any | null = null;
    errors: any = {};
    apiSectionName = 'ESPACE DÉVELOPPEUR';
    fluxSectionName = "ESPACE FLUX";
    

    get type(): 'edit' | 'add' {
        return this.$route.name === 'addCompany' ? 'add' : 'edit';
    }

    get items() {
        return [
            {
                name: 'image',
                label: 'Logo entreprise',
                type: 'image',
                accept: 'image/png',
            },
            {
                name: 'name',
                label: "Nom de l'entreprise *",
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'nb_of_stars',
                label: "Note Promoteur",
                type: 'number',
                min: 0,
                max: 5,
                step: 1
            },
            {
                name: 'promotor_note_comments',
                label: "Commentaire Promoteur",
                type: 'text',
            },
            {
                name: 'email',
                label: 'Email général *',
                type: 'email',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'legal_form',
                label: 'Forme juridique',
                type: 'select',
                items: this.legalFormsArr,
                placeholder: 'À renseigner',
                errorMessage: 'La forme juridique est requise',
            },
            {
                name: 'type',
                label: "Type d'entreprise *",
                type: 'select',
                errorMessage: 'Le type est requis',
                required: true,
                items: this.companyTypesArr,
            },
            {
                name: 'siret',
                label: 'Siret',
                type: 'text',
            },
            {
                name: 'description',
                label: 'Présentation promoteur (Affichée côté utilisateur)',
                type: 'textarea',
            },
            {
                name: 'holding',
                label: 'Entreprise parente',
                type: 'select',
                items: [{ text: 'Aucune', value: '' }, ...this.companiesItems],
            },
            {
                name: 'full_name_commercial_director',
                label: 'Nom du directeur commercial',
                type: 'text'
            },
            {
                name: 'mail_commercial_director',
                label: 'E-Mail du directeur commercial',
                type: 'email'
            },
            {
                name: 'phone_nb_commercial_director',
                label: 'Tel Mobile Directeur Commercial',
                type: 'text',
            },
            {
              name: 'comments',
              label: 'Commentaires service commercial (Chargé d\'Affaires)',
              type: 'textarea',
            },
            {
              name: 'commercial_manager_name',
              label: 'Nom du responsable des ventes',
              type: 'text',
            },
            {
                name: 'commercial_manager_email',
                label: 'E-mail du responsable des ventes',
                type: 'email',
            },
            {
                name: 'commercial_manager_phone',
                label: 'Tel fixe responsable ventes',
                type: 'text',
            },
            {
                name: 'commercial_manager_mobile',
                label: 'Tel mobile responsable ventes',
                type: 'text',
            },
            {
                name: 'account_manager_name',
                label: 'Nom du responsable comptabilité',
                type: 'text',
            },
            {
                name: 'account_manager_email',
                label: 'E-mail du responsable comptabilité',
                type: 'email',
            },
            {
                name: 'account_manager_phone',
                label: 'Tel fixe compta',
                type: 'text',
            },
            {
                name: 'account_manager_mobile',
                label: 'Tel mobile compta',
                type: 'text',
            },
            {
              name: 'billing_comments',
              label: 'Compta / Facturation',
              type: 'textarea',
            },
            {
              name: 'rear_margin_comments',
              label: 'Marge arrière / Prime sur Objectif',
              type: 'textarea',
            },
            {
                name: 'url',
                label: 'Site partenaire',
                type: 'text',
            },
            {
                name: 'login_site',
                label: 'Identifiant (Site partenaire)',
                type: 'text',
            },
            {
                name: 'password_site',
                label: 'Mot de passe (Site partenaire)',
                type: 'text',
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse *',
                        name: 'street',
                        required: true,
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal *',
                        name: 'postal_code',
                        required: true,
                    },
                    city: {
                        label: 'Ville *',
                        name: 'city',
                        required: true,
                    },
                },
            },
            {
              name: 'seller_infos',
              label: 'Infos Vendeur (Affichées côté utilisateur)',
              type: 'textarea'
            },
            {
              name: 'heart_stroke',
              label: 'Coup de coeur (Affichées côté utilisateur)',
              type: 'textarea'
            },
            {
                name: 'nb_total_programs',
                label: 'Nb total programmes',
                type: 'number',
                min: 0,
            },
            {
                name: 'nb_programs_to_enter',
                label: 'Nb Prog à saisir',
                type: 'number',
                min: 0,
            },
            {
                name: 'public_site_url',
                label: "Site Public de l'Entreprise",
                type: 'string',
            },
            {
                name: 'brochure_',
                label: 'Plaquette présentation de la société',
                current: 'brochure',
                type: 'custom-file',
                fields: {
                    name: 'brochure_filename',
                    content: 'brochure_file',
                },
            },
            {
                name: 'booking_instructions',
                label: 'Consignes particulières pour Dénoncer, Optionner et Réserver',
                type: 'textarea',
            },
            {
                name: 'booking_doc_',
                label: 'Fichier consigne Réservation (Affichées côté utilisateur)',
                current: 'booking_doc',
                type: 'custom-file',
                fields: {
                    name: 'booking_doc_filename',
                    content: 'booking_doc_file',
                },
            },
            {
                name: 'administrative_comment',
                label: 'Commentaires BackOffice',
                type: 'textarea',
            },
            {
                name: 'electronic_signature_mandate',
                label: 'Signature électro. Mandat',
                type: 'select',
                items: [
                    { text: 'Oui', value: 'yes' },
                    { text: 'Non', value: 'no' },
                    { text: 'À confirmer', value: 'pending' },
                ],
            },
            {
                name: 'is_multi_mandat',
                label: 'Mandat de vente',
                type: 'select',
                items: [
                    { text: 'À déterminer', value: '' },
                    { text: 'Multi-programmes', value: 'yes' },
                    { text: 'Mandat à la réservation', value: 'res' },
                    { text: 'Par programmes', value: 'no' },
                ],
            },
            {
                name: 'mandat_num_mandat',
                label: 'Numéro de mandat',
                type: 'number',
                requires: ['is_multi_mandat', 'yes'],
            },
            {
                name: 'mandat_mandat',
                label: 'Pièce jointe mandat',
                type: 'custom-file',
                requires: ['is_multi_mandat', 'yes'],
                current: 'mandat_file',
                fields: {
                    name: 'mandat_mandat_filename',
                    content: 'mandat_mandat_file',
                },
            },
            {
                name: 'mandat_date_due',
                label: "Date d'échéance du mandat",
                type: 'date',
                requires: ['is_multi_mandat', 'yes'],
            },
            {
                name: 'electronic_signature_contract',
                label: 'Signature électro. Contrat résa',
                type: 'select',
                items: [
                    { text: 'Généré par le vendeur', value: 'yes' },
                    { text: 'Générée par nous', value: 'yesInt' },
                    { text: 'Signature Papier uniquement', value: 'no' },
                    { text: 'Non déterminée', value: 'pending' },
                ],
            },
            {
                name: 'paper_signature_contract',
                label: 'Signature Papier Contrat résa',
                type: 'select',
                items: [
                    { text: 'Oui', value: 'yes' },
                    { text: 'Non', value: 'no' },
                    { text: 'Ne sais pas', value: 'pending' },
                ],
            },
            {
                name: 'denounce_method',
                label: 'Méthode pour Dénoncer',
                type: 'select',
                items: [
                    { text: 'A confirmer', value: 'to_confirm' },
                    { text: 'Sur site partenaire', value: 'part_website' },
                    { text: 'Par Tel', value: 'mobile' },
                    { text: 'Par Email', value: 'mail' },
                    { text: 'Par Tel et Email', value: 'mail_or_mobile' },
                    { text: 'Aucune denonce possible', value: 'no_denounce' },
                ],
            },
            {
                name: 'option_method',
                label: 'Méthode pour Optionner',
                type: 'select',
                items: [
                    { text: 'A confirmer', value: 'to_confirm' },
                    { text: 'Sur site partenaire', value: 'part_website' },
                    { text: 'Par Tel', value: 'mobile' },
                    { text: 'Par Email', value: 'mail' },
                    { text: 'Par Tel et Email', value: 'mail_or_mobile' },
                    { text: 'Aucune option possible', value: 'no_option' },
                ],
            },
            {
                name: 'booking_method',
                label: 'Méthode pour Réserver',
                type: 'select',
                items: [
                    { text: 'A confirmer', value: 'to_confirm' },
                    { text: 'Sur site partenaire', value: 'part_website' },
                    { text: 'Par Tel', value: 'mobile' },
                    { text: 'Par Email', value: 'mail' },
                    { text: 'Par Tel et Email', value: 'mail_or_mobile' },
                ],
            },
            {
                name: 'crm',
                label: 'CRM',
                type: 'select',
                items: [
                    { text: 'À déterminer', value: '' },
                    { text: 'Oui', value: 'yes' },
                    { text: 'Non', value: 'no' },
                ],
            },
            {
                name: 'supplier',
                label: 'Fournisseur',
                type: 'text',
                requires: ['crm', 'yes'],
            },
            {
                name: 'is_multi_fee',
                label: 'Honoraires HT',
                type: 'select',
                items: [
                    { text: 'À déterminer', value: '' },
                    { text: 'Multi-programme', value: 'yes' },
                    { text: 'Par programme', value: 'no' },
                ],
            },
            {
                name: 'duty_free_fee',
                label: 'Honoraires (%)',
                type: 'number',
                requires: ['is_multi_fee', 'yes'],
            },
            {
                name: 'multi_boost',
                label: 'Boost Commercial',
                type: 'select',
                items: [
                    { text: 'À déterminer', value: '' },
                    { text: 'Multi-programme', value: 'yes' },
                    { text: 'Par programme', value: 'no' },
                ],
            },
            {
                name: 'boost_due_date_prescriber',
                label: 'Date Limite boost hono.',
                type: 'date',
                requires: ['multi_boost', 'yes'],
            },
            {
                name: 'boost_comment_prescriber',
                label: 'Commentaire boost hono.',
                type: 'textarea',
                requires: ['multi_boost', 'yes'],
            },
            {
              name: 'boost_due_date_customer',
              label: 'Date Limite avant. client',
              type: 'date',
              requires: ['multi_boost', 'yes'],
            },
            {
                name: 'boost_comment_customer',
                label: 'Commentaire avant. client',
                type: 'textarea',
                requires: ['multi_boost', 'yes'],
            },
            {
                name: 'is_boost_prescriber',
                label: 'Boost hono.',
                type: 'switch',
                requires: ['multi_boost', 'yes'],
            },
            {
                name: 'is_boost_customer',
                label: 'Avant. client',
                type: 'switch',
                requires: ['multi_boost', 'yes'],
            },
            {
                name: 'business_developper',
                label: 'Business Developper *',
                type: 'select',
                items: this.businessDeveloppers,
                required: true,
            },
            /* API */
            {
                name: 'api_available',
                label: 'Espace partenaire',
                type: 'switch',
                section: this.apiSectionName,
                sectionChunked: false,
            },
            {
                name: 'api_connected',
                label: 'Flux connecté (désactive également des crons)',
                type: 'switch',
                section: this.apiSectionName,
                sectionChunked: false,
            },
            {
                name: 'document_file',
                label: 'API documentation fichier 1',
                type: 'custom-file',
                current: 'api_documentation',
                fields: {
                    name: 'document_name',
                    content: 'document',
                },
                section: this.apiSectionName,
                sectionChunked: false,
            },
            {
                name: 'document2_file',
                label: 'API documentation fichier 2',
                type: 'custom-file',
                current: 'api_documentation2',
                fields: {
                    name: 'document2_name',
                    content: 'document2',
                },
                section: this.apiSectionName,
                sectionChunked: false,
            },
            {
                name: 'document3_file',
                label: 'API documentation fichier 3',
                type: 'custom-file',
                current: 'api_documentation3',
                fields: {
                    name: 'document3_name',
                    content: 'document3',
                },
                section: this.apiSectionName,
                sectionChunked: false,
            },
            {
                name: 'dev_comment',
                label: 'Commentaire dev',
                type: 'textarea',
                section: this.apiSectionName,
                sectionChunked: false,
            },
            //FLUX
            {
                name: 'flux_methode',
                label: 'Méthode de Flux',
                type: 'select',
                items: this.methodesFlux,
                required: false,
                section: this.fluxSectionName,
                sectionChunked: false,
            }
        ];
    }

    value: any | null = null;
    defaultValue: any = {
        name: null,
        description: null,
        holding: '',
        commercial_manager: null,
        type: null,
        url: null,
        login_site: null,
        password_site: null,
        siret: null,
        legal_form: null,
        email: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        comments: null,
        full_name_commercial_director: null,
        mail_commercial_director: null,
        phone_nb_commercial_director: null,
        commercial_manager_name: null,
        commercial_manager_email: null,
        commercial_manager_phone: null,
        commercial_manager_mobile: null,
        account_manager_name: null,
        account_manager_email: null,
        account_manager_phone: null,
        account_manager_mobile: null,
        nb_total_programs: 0,
        nb_programs_to_enter: 0,
        public_site_url: null,
        administrative_comment: null,
        billing_comments: null,
        electronic_signature_mandate: 'pending',
        electronic_signature_contract: 'pending',
        paper_signature_contract: 'pending',
        crm: '',
        supplier: '',
        is_multi_fee: '',
        duty_free_fee: null,
        is_multi_mandat: '',
        mandat_num_mandat: null,
        mandat_date_due: null,
        mandat_file:null,
        business_developper: null,
        // api
        api_available: null,
        api_connected: null,
        dev_comment: null,
        //flux
        flux_methode: null,
        // api documentation
        document_file: null,
        document2_file: null,
        document3_file: null,
        api_documentation: null,
        multi_boost: null,
        boost_due_date_prescriber: null,
        boost_due_date_customer: null,
        boost_comment_prescriber: null,
        boost_comment_customer: null,
        is_boost_prescriber: null,
        is_boost_customer: null,
        brochure: null,
        seller_infos: null,
        heart_stroke: null,
        nb_of_stars: null,
        promotor_note_comments: null,
        rear_margin_comments: null,
        booking_instructions: null,
        denounce_method: null,
        option_method: null,
        booking_method: null,
    };

    getValue(value: any) {
        this.value = value;
    }

    async created(): Promise<void> {
        this.loading = true;
        const dataCompanies = await getCompanies();
        const companies = dataCompanies.data;
        this.companiesItems = companies.map((item: Company) => ({
            value: item.id || 0,
            text: item.name,
        }));

        const dataBusinessDeveloppers = await getBusinessDevelopers();
        this.businessDeveloppers = dataBusinessDeveloppers.data.map(
            (item: User) => ({
                text: item.firstname + " - " + item.email,
                value: item.id || 0,
            })
        );

        this.methodesFlux = [
            {
                text: 'Aucun',
                value: ''

            },
            {
                text: 'FTP interne',
                value: 'ftp_interne'
            },
            {
                text: 'FTP externe',
                value: 'ftp_externe'
            },
            {
                text: 'API (JSON)',
                value: 'json_api'
            },
            {
                text: 'Flux externe JSON',
                value: 'flux_externe_json'
            },
            {
                text: 'Flux externe XML',
                value: 'flux_externe_xml'
            },
            {
                text: 'Webservice SOAP',
                value: 'soap'
            }
        ];

        if (this.type === 'edit' && this.company) {
            this.defaultImages =
                this.company.image &&
                `${BACKEND_URL}${this.company.image.url}${this.company.image.name}.${this.company.image.extension}`;

            this.defaultValue.name = this.company.name || null;
            this.defaultValue.description = this.company.description || null;
            this.defaultValue.holding = this.company.holding
                ? this.company.holding.id
                : '';
            this.defaultValue.type = this.company.type || null;
            this.defaultValue.url = this.company.url || null;
            this.defaultValue.login_site = this.company.login_site || null;
            this.defaultValue.password_site =
                this.company.password_site || null;
            this.defaultValue.siret = this.company.siret || null;
            this.defaultValue.legal_form = this.company.legal_form || null;
            this.defaultValue.full_name_commercial_director = this.company.full_name_commercial_director || null;
            this.defaultValue.mail_commercial_director = this.company.mail_commercial_director || null;
            this.defaultValue.phone_nb_commercial_director = this.company.phone_nb_commercial_director || null;
            this.defaultValue.email = this.company.email || null;
            this.defaultValue.fax = this.company.fax || null;
            this.defaultValue.phone = this.company.phone || null;
            this.defaultValue.mobile = this.company.mobile || null;
            this.defaultValue.address.street =
                (this.company.address && this.company.address.street) || null;
            this.defaultValue.address.street2 =
                (this.company.address && this.company.address.street2) || null;
            this.defaultValue.address.postal_code =
                (this.company.address && this.company.address.postal_code) ||
                null;
            this.defaultValue.address.city =
                (this.company.address && this.company.address.city) || null;
            this.defaultValue.comments = this.company.comments || null;
            this.defaultValue.commercial_manager_name =
                this.company.commercial_manager_name || null;
            this.defaultValue.commercial_manager_email =
                this.company.commercial_manager_email || null;
            this.defaultValue.commercial_manager_phone =
                this.company.commercial_manager_phone || null;
            this.defaultValue.commercial_manager_mobile =
                this.company.commercial_manager_mobile || null;
            this.defaultValue.account_manager_name =
                this.company.account_manager_name || null;
            this.defaultValue.account_manager_email =
                this.company.account_manager_email || null;
            this.defaultValue.account_manager_phone =
                this.company.account_manager_phone || null;
            this.defaultValue.account_manager_mobile =
                this.company.account_manager_mobile || null;
            this.defaultValue.nb_total_programs =
                this.company.nb_total_programs || 0;
            this.defaultValue.nb_programs_to_enter =
                this.company.nb_programs_to_enter || 0;
            this.defaultValue.public_site_url =
                this.company.public_site_url || null;
            this.defaultValue.seller_infos = this.company.seller_infos || null;
            this.defaultValue.heart_stroke = this.company.heart_stroke || null;
            this.defaultValue.denounce_method = this.company.denounce_method || null;
            this.defaultValue.option_method = this.company.option_method || null;
            this.defaultValue.booking_method = this.company.booking_method || null;
            this.defaultValue.administrative_comment =
                this.company.administrative_comment || null;
            this.defaultValue.billing_comments =
                this.company.billing_comments || null;
            this.defaultValue.electronic_signature_mandate =
                this.company.electronic_signature_mandate || 'pending';
            this.defaultValue.electronic_signature_contract =
                this.company.electronic_signature_contract || 'pending';
            this.defaultValue.paper_signature_contract =
                this.company.paper_signature_contract || null;
            this.defaultValue.crm = this.company.crm || '';
            this.defaultValue.supplier = this.company.supplier || '';
            this.defaultValue.is_multi_fee = this.company.is_multi_fee || '';
            this.defaultValue.duty_free_fee = this.company.duty_free_fee || '';
            this.defaultValue.multi_boost = this.company.multi_boost || '';
            this.defaultValue.promotor_note_comments = this.company.promotor_note_comments || null;
            this.defaultValue.rear_margin_comments = this.company.rear_margin_comments || null;
            this.defaultValue.booking_instructions = this.company.booking_instructions || null;
            this.defaultValue.nb_of_stars = this.company.nb_of_stars || null;
            this.defaultValue.boost_due_date_prescriber =
                (this.company.boost_due_date_prescriber &&
                    moment(this.company.boost_due_date_prescriber)) ||
                null;
            this.defaultValue.boost_due_date_customer =
                (this.company.boost_due_date_customer &&
                    moment(this.company.boost_due_date_customer)) ||
                null;
            this.defaultValue.boost_comment_prescriber =
                this.company.boost_comment_prescriber || '';
            this.defaultValue.boost_comment_customer =
                this.company.boost_comment_customer || '';
            this.defaultValue.is_boost_prescriber =
                this.company.is_boost_prescriber || false;
            this.defaultValue.is_boost_customer =
                this.company.is_boost_customer || false;
            this.defaultValue.is_multi_mandat =
                this.company.is_multi_mandat || '';
            this.defaultValue.business_developper = this.company.business_developper ?
                this.company.business_developper.id : null;

            // api
            this.defaultValue.api_available =
                this.company.api_available || null;
            this.defaultValue.api_connected =
                this.company.api_connected || null;
            this.defaultValue.dev_comment = this.company.dev_comment || null;
            this.defaultValue.mandat_num_mandat = this.company.mandat
                ? this.company.mandat.num_mandat
                : null;
            this.defaultValue.mandat_date_due = this.company.mandat
                ? moment(this.company.mandat.date_due)
                : null;

            //flux
            this.defaultValue.flux_methode = this.company.flux_methode || null;

            // api documentation
            if (this.company.api_documentation) {
                const current: FileCurrent = {
                    name: `${this.company.api_documentation.name}.${this.company.api_documentation.extension}`,
                    url: `${BACKEND_URL}${this.company.api_documentation.url}${this.company.api_documentation.name}.${this.company.api_documentation.extension}`,
                };

                this.defaultValue.api_documentation = current;
            }

            if (this.company.api_documentation2) {
                const current: FileCurrent = {
                    name: `${this.company.api_documentation2.name}.${this.company.api_documentation2.extension}`,
                    url: `${BACKEND_URL}${this.company.api_documentation2.url}${this.company.api_documentation2.name}.${this.company.api_documentation2.extension}`,
                };

                this.defaultValue.api_documentation2 = current;
            }

            if (this.company.api_documentation3) {
                const current: FileCurrent = {
                    name: `${this.company.api_documentation3.name}.${this.company.api_documentation3.extension}`,
                    url: `${BACKEND_URL}${this.company.api_documentation3.url}${this.company.api_documentation3.name}.${this.company.api_documentation3.extension}`,
                };

                this.defaultValue.api_documentation3 = current;
            }

            if (this.company.brochure) {
                const current: FileCurrent = {
                    name: `${this.company.brochure.name}.${this.company.brochure.extension}`,
                    url: `${BACKEND_URL}${this.company.brochure.url}${this.company.brochure.name}.${this.company.brochure.extension}`,
                };

                this.defaultValue.brochure = current;
            }
            if (this.company.booking_doc) {
                const current: FileCurrent = {
                    name: `${this.company.booking_doc.name}.${this.company.booking_doc.extension}`,
                    url: `${BACKEND_URL}${this.company.booking_doc.url}${this.company.booking_doc.name}.${this.company.booking_doc.extension}`,
                };

                this.defaultValue.booking_doc = current;
            }

            if (this.company.mandat && this.company.mandat.mandat_file) {
                const current: FileCurrent = {
                    name: `${this.company.mandat.mandat_file.name}.${this.company.mandat.mandat_file.extension}`,
                    downloadMandat: this.company,
                };

                this.defaultValue.mandat_file = current;
            }

        }
        this.loading = false;
    }

    saveLastUpdate() {
        if (this.company != null) {
            patchCompanyContactedAt(this.company.id as number)
                .then(resp => {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'success',
                        position: 'top-right',
                        title: 'Sauvegarde réussie',
                        text: 'Sauvegarde date dernière Maj réussie',
                    });
                })
                .catch(() => {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: 'Sauvegarde date dernière Maj échouée',
                    });
                });
        }
    }

    async submit(form: any) {
        this.loading = true;
        /**
         * when we click on the cross it didn't clear the holding if this code is not here
         */
        if(typeof form.holding == undefined) {
          form.holding = '';
        }
        const newCompany: Company = {
            name: form.name,
            image: form.image,
            description: form.description,
            type: form.type,
            nb_of_stars: form.nb_of_stars,
            promotor_note_comments: form.promotor_note_comments,
            holding: form.holding,
            url: form.url,
            login_site: form.login_site,
            password_site: form.password_site,
            siret: form.siret,
            email: form.email,
            bic: form.bic,
            full_name_commercial_director: form.full_name_commercial_director,
            mail_commercial_director: form.mail_commercial_director,
            phone_nb_commercial_director: form.phone_nb_commercial_director,
            legal_form: form.legal_form || '',
            rcs: form.rcs,
            share_capital: form.share_capital,
            fax: form.fax,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            nb_total_programs: form.nb_total_programs,
            nb_programs_to_enter: form.nb_programs_to_enter,
            public_site_url: form.public_site_url,
            electronic_signature_mandate: form.electronic_signature_mandate,
            electronic_signature_contract: form.electronic_signature_contract,
            paper_signature_contract: form.paper_signature_contract,
            comments: form.comments,
            seller_infos: form.seller_infos,
            heart_stroke: form.heart_stroke,
            administrative_comment: form.administrative_comment,
            billing_comments: form.billing_comments,
            commercial_manager_name: form.commercial_manager_name,
            commercial_manager_email: form.commercial_manager_email,
            commercial_manager_phone: form.commercial_manager_phone,
            commercial_manager_mobile: form.commercial_manager_mobile,
            account_manager_name: form.account_manager_name,
            account_manager_email: form.account_manager_email,
            account_manager_phone: form.account_manager_phone,
            account_manager_mobile: form.account_manager_mobile,
            crm: form.crm,
            supplier: form.crm === 'yes' ? form.supplier : '',
            is_multi_fee: form.is_multi_fee,
            duty_free_fee: form.is_multi_fee === 'yes' ? form.duty_free_fee : 0,
            business_developper: form.business_developper,
            multi_boost: form.multi_boost,
            boost_due_date_prescriber:
                form.multi_boost === 'yes'
                    ? form.boost_due_date_prescriber
                    : '',
            boost_due_date_customer:
                form.multi_boost === 'yes' ? form.boost_due_date_customer : '',
            boost_comment_prescriber:
                form.multi_boost === 'yes' ? form.boost_comment_prescriber : '',
            boost_comment_customer:
                form.multi_boost === 'yes' ? form.boost_comment_customer : '',
            is_boost_prescriber:
                form.multi_boost === 'yes' ? form.is_boost_prescriber : '',
            is_boost_customer:
                form.multi_boost === 'yes' ? form.is_boost_customer : '',
            is_multi_mandat: form.is_multi_mandat,
            mandat:
                form.is_multi_mandat !== 'yes'
                    ? undefined
                    : {
                        num_mandat: form.mandat_num_mandat,
                        date_due: form.mandat_date_due,
                        mandat_file: form.mandat_mandat_file,
                    },

            // api
            api_available: form.api_available,
            api_connected: form.api_connected,
            dev_comment: form.dev_comment,

            //flux
            flux_methode: form.flux_methode,

            // api documentation
            document: form.document,
            document_name: form.document_name,
            document2: form.document2,
            document2_name: form.document2_name,
            document3: form.document3,
            document3_name: form.document3_name,
            brochure_file: form.brochure_file,
            brochure_filename: form.brochure_filename,
            booking_doc_file: form.booking_doc_file,
            booking_doc_filename: form.booking_doc_filename,
            rear_margin_comments: form.rear_margin_comments,
            booking_instructions: form.booking_instructions,
            denounce_method: form.denounce_method,
            option_method: form.option_method,
            booking_method: form.booking_method,
        };

        const $vs = (this as any).$vs;
        try {
            if (this.type === 'add') {
                await postCompany(newCompany);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création de l'entreprise réussie`,
                });
            } else {
                await patchCompany(+this.$route.params.id, newCompany);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification de l'entreprise réussie`,
                });
            }
            this.$router.push({ name: 'companies' });
        } catch (error) {
            this.errors = get(error, 'response.data.errors.children', {});

            const message = get(
                error,
                'response.data.message',
                'Erreur lors de la soumission du formulaire'
            );
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.loading = false;
        }
    }

    get legalFormsArr() {
        return Object.keys(legalForms).map(key => ({
            text: (legalForms as any)[key],
            value: key,
        }));
    }

    get companyTypesArr() {
        return Object.keys(companyTypes).map(key => ({
            text: (companyTypes as any)[key],
            value: key,
        }));
    }
}
